import axios from 'axios';
import { message, Modal } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { authService } from '../auth/auth-service';
import config from "../config";
import { getCsrfToken } from '../auth/csrf';
let isSessionModalOpen = false; // 🔒 prevent duplicate modals

const paramsSerializer = (params) => new URLSearchParams(
  Object.entries(params || {}).map(([k,v]) => [k, v ?? ''])
).toString();

const http = axios.create({
  baseURL: config.BASE_URL,
  paramsSerializer,
  withCredentials: true,
});

/* =========================
   REQUEST INTERCEPTOR
========================= */
http.interceptors.request.use(async (request) => {
  request.headers = { ...request.headers };
  const method = (request.method || 'get').toLowerCase();
  if (!['get', 'head', 'options'].includes(method)) {
    request.headers['X-CSRF-TOKEN'] = await getCsrfToken();
  }
  return request;
});

/* =========================
   RESPONSE INTERCEPTOR
========================= */
http.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error?.response?.status;
		const apiMessage =
			error?.response?.data?.message ||
			'Your session has expired or you are not authorized.';

		/* ---------- 403 : SESSION EXPIRED / FORBIDDEN ---------- */
		if (status === 403 && !isSessionModalOpen) {
			isSessionModalOpen = true;

            // Do not destroy the session for a role-based 403; report access denied.

			Modal.confirm({
				title: (
					<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						<LogoutOutlined style={{ color: '#ff4d4f', fontSize: 20 }} />
						<span>Access Denied</span>
					</div>
				),
				content: apiMessage,
				okText: 'Close',
				cancelButtonProps: { style: { display: 'none' } },
				closable: false,
				maskClosable: false,
				centered: true,
				okButtonProps: {
					type: 'primary',
					style: {
						background: '#EB3680',
						borderColor: '#EB3680',
					},
				},
				width: 420,
				bodyStyle: { padding: '20px 24px' },
				onOk: () => {
					isSessionModalOpen = false;
					window.close(); // 🔚 hard stop
				},
			});

			return Promise.reject(error);
		}

		/* ---------- 401 : UNAUTHORIZED ---------- */
		if (status === 401 && authService.isAuthenticated()) {
			authService.logout?.();
			message.error('You are not authorized to perform this action.');
			return Promise.reject(error);
		}

		/* ---------- OTHER ERRORS ---------- */
		if (status && status !== 403 && status !== 401) {
			message.error({
				content: `Error ${status}: ${apiMessage}`,
				key: 'api-error',
				duration: 2,
			});
		}

		return Promise.reject(error);
	}
);

export default http;
